import { ReactNode } from 'react';

import useMediaQuery from '@sureapp/wl-toggle-common/dist/hooks/useMediaQuery';
import { NavLink } from 'react-router-dom';

import Button from '../Button';

import classes from './NavBar.module.css';
import NavFooter from './NavFooter';
import { TNavMenuItem } from './NavMenuItem';
import NavMenuList, { TMenuLink } from './NavMenuList';
import { useNavLinks } from './useNavLinks';

export type TNavBarMenu = Pick<TNavMenuItem, 'onToggleMenu'> & {
  links: NonNullable<ReturnType<typeof useNavLinks>>;
  phoneLink: ReactNode;
};

function LoginLogoutButton({ to, title }: TMenuLink) {
  const isDesktop = useMediaQuery('(min-width: 936px)');

  return isDesktop ? (
    <Button
      as={NavLink}
      to={to}
      variant="SECONDARY"
      size="xs"
      data-testid="login-logout-link"
      overrideClasses={{ root: classes.logout }}
      label={title}
    />
  ) : (
    <NavLink to={to} className={classes.logout} data-testid="login-logout-link">
      {title}
    </NavLink>
  );
}

function NavBarMenu({ onToggleMenu, links, phoneLink }: TNavBarMenu) {
  return (
    <div className={classes.menu}>
      <NavMenuList onToggleMenu={onToggleMenu} menuLinks={links.main} />
      {!links.shouldHidePhoneLink && phoneLink}
      {links.loginLogout && <LoginLogoutButton {...links.loginLogout} />}
      <NavFooter
        footerLinks={links.footer}
        shouldHideSocialLinks={links.shouldHideSocialLinks}
      />
    </div>
  );
}

export default NavBarMenu;
